import { useEffect, useMemo } from 'react';
import { ChromeWebstoreTeaser } from '~/components/ChromeWebstoreTeaser';
import { TermsFooter } from '~/components/TermsFooter';
import useCookieStorage from '~/hooks/useCookieStorage';
import useFeature from '~/hooks/useFeature';
import useGetBrowserName from '~/hooks/useGetBrowserName';
import { EXTENSION_INSTALLED_COOKIE_NAME } from '~/scripts/constants';
import { getPageMetaTags } from '~/scripts/getPageMetaTags';
import type { Route } from './+types/_index';
import { HomepageV3 } from '~/components/HomepageV3';
import api from '~/api/Endpoints';
import { FAQS } from '~/components/HomepageV3/WhatIsSection';
export const meta: Route.MetaFunction = () => {
  return getPageMetaTags({
    title: "NerdyData.com - Search The Web's Source Code for Technologies",
    description:
      'Search Engine For Source Code. Find websites using technology, HTML, Javascript, CSS Tags.',
    image: 'https://static.nerdydata.com/img/explorer.png',
    canonical: 'https://www.nerdydata.com',
    faq: [...FAQS],
  });
};

export const loader = async ({ context: _context }: Route.LoaderArgs) => {
  return null;
};

export default function Homepage({}: Route.ComponentProps) {
  const browserName = useGetBrowserName();
  const [extensionInstalled] = useCookieStorage(
    EXTENSION_INSTALLED_COOKIE_NAME,
    ''
  );
  const [extensionTeaserFeature] = useFeature('extension_teaser');
  const extensionTeaserEligible = useMemo(() => {
    return (
      extensionTeaserFeature &&
      !extensionInstalled &&
      ['Chrome', 'Firefox'].includes(browserName)
    );
  }, [extensionTeaserFeature, extensionInstalled, browserName]);

  useEffect(() => {
    api.post('/app/events', {
      body: {
        type: 'homepage',
      },
    });
  });
  return (
    <div>
      <HomepageV3 />
      {extensionTeaserEligible && <ChromeWebstoreTeaser />}
      <TermsFooter />
    </div>
  );
}
